import { str } from 'envalid';

export class FeedbackEnvConfig {
  private static readonly schema = {
    FEEDBACK_GITHUB_REPO: str({
      desc: 'Target GitHub repository for feedback issues (format: owner/repo)',
      example: 'inovisum/private-repo',
    }),
    FEEDBACK_GITHUB_TOKEN: str({
      desc: 'GitHub Personal Access Token with repo scope (used to create issues)',
      example: 'ghp_***',
    }),
  } as const;

  private constructor() {}

  public static getSchema() {
    return FeedbackEnvConfig.schema;
  }
}

